export class Bank {
    id: string;
    organization_id: string;
    branch_id: string;
    name: string;
    account_no: string;
    status: string;

    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/banks/bank.ts